module.exports = __webpack_public_path__ + "static/media/iphone.33c45307.png";